import React from 'react';
import { Row, Col, Image } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useApplicationContext } from '@/context/v1/Application/context';
import { PROFILE_DEFAULT } from '@/utils/enum';
import { TitleContainer } from './styles';

export function Header() {
	const { organization, company } = useApplicationContext();

	const company_logo = company?.url_logo !== PROFILE_DEFAULT.URL ? company?.url_logo : undefined;
	const profile_logo = company_logo ?? organization?.url_logo;

	return (
		<Row align="middle" gutter={[30, 0]}>
			<Col span={18}>
				<Row align="middle" gutter={[60, 0]}>
					<Col span={8}>
						<Image
							preview={{ visible: false, mask: false }}
							src="https://kinebot-statics.s3.amazonaws.com/kinebot_logo.png"
						/>
					</Col>
					<Col span={16}>
						<TitleContainer>
							<span>{I18n.get('Results')}</span>
							<span id="title">{I18n.get('ROSA')}</span>
						</TitleContainer>
					</Col>
				</Row>
			</Col>
			<Col span={6} style={{ display: 'flex', justifyContent: 'center' }}>
				<Image
					preview={false}
					src={profile_logo || PROFILE_DEFAULT.URL}
					style={{ maxHeight: 100, objectFit: 'contain' }}
				/>
			</Col>
		</Row>
	);
}
